import { forwardRef } from 'react';
import { Trans } from '@lingui/react/macro';
import { Button } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useMobile } from 'shared/domains/common-ui';
export const ResponsiveButton = forwardRef((props, forwardedRef) => {
    const { onClick } = props;
    const isMobile = useMobile();
    return (<Button ref={forwardedRef} size={isMobile ? 'small' : 'medium'} appearance="secondary" onClick={onClick}>
      <Falcon icon="layer-plus"/>
      <Trans comment="Create team button text">New team</Trans>
    </Button>);
});
